export const getEnrollSteps = <isPNELEnabled extends boolean = false>(
  isPNELENabled: isPNELEnabled
) => {
  const firstSteps = [
    {
      /** 0 */ name: isPNELENabled ? 'About You' : 'You',
    },
    {
      /** 1 */ name: 'Documents',
    },
    {
      /** 2 */ name: 'Contact',
    },
    {
      /** 3 */ name: 'Eligibility',
    },
  ] as const

  const pnelLastSteps = [
    {
      /** 4 */ name: 'Finalize Details',
    },
    {
      /** 5 */ name: 'Done',
    },
  ] as const

  const standardLastStep = [
    {
      /** 4 */ name: 'Location',
    },
    {
      /** 5 */ name: 'Complete',
    },
  ] as const

  const lastSteps = isPNELENabled ? pnelLastSteps : standardLastStep
  return [...firstSteps, ...lastSteps] as isPNELEnabled extends true
    ? [...typeof firstSteps, ...typeof pnelLastSteps]
    : [...typeof firstSteps, ...typeof standardLastStep]
}

export const RENEWAL_STEPS = [
  {
    /** 0 */ name: 'Eligibility',
  },
  {
    /** 1 */ name: 'Contact',
  },
  {
    /** 2 */ name: 'Pay',
  },
  {
    /** 3 */ name: 'Complete',
  },
] as const
